export const DAY_1_IN_MS = 86400000
